import { render, staticRenderFns } from "./ReverseNote.vue?vue&type=template&id=753790c8&"
import script from "./ReverseNote.vue?vue&type=script&lang=js&"
export * from "./ReverseNote.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports